import { CASH_FLOW_MODULE_URL } from "../../../constant/contact.module-config";

export const CASH_OUT_MODULE_NAME = "Phiếu chi";
export const CASH_OUT_MODULE_URL = CASH_FLOW_MODULE_URL + "/cash-out";
export const CASH_OUT__API_PATH = "/v1/cash-out";
